import Icon, { IconClassName, icons, IconText } from '../../generic/Icon';
import { RouterLink } from '../../generic/Link';
import Loader from '../../generic/Loader';

type SummaryStatPanelProps = {
  to: string;
  count: string | number;
  label: string;
  icon: IconClassName;
  isLoading: boolean;
  className?: string;
};

/**
 * Generic component for rendering a stat panel button on the project summary page.
 *
 * @param {string} to - Where the user should be redirected to upon clicking the action button.
 * @param {string | number} count - The count of the stat. Can be '...'
 * @param {string} label - What stat is being displayed.
 * @param {IconClassName} icon - The icon to display.
 * @param {boolean} isLoading - If the stat is still loading.
 * @param {string} [className] - Optional additional styling class.
 */

const SummaryStatPanel = ({
  to,
  count,
  label,
  icon,
  isLoading,
  className = '',
}: SummaryStatPanelProps) =>
  <RouterLink
    to={to}
    className={`panel panel-stat project-summary-panel-stat ${className}`}
  >
    <h1>
      {isLoading ? <Loader /> : count}
    </h1>
    <b className="inline-header">
      <IconText
        icon={icon}
        text={label}
      />
      <span className="margin-left-xs arrow-link">
        <Icon icon={icons.angleDoubleRight} />
      </span>
    </b>
  </RouterLink>;

export default SummaryStatPanel;
